import { VariantProps, cva } from 'class-variance-authority';

export const tagStyles = cva(
  ['rounded-full text-nowrap leading-none h-fit flex items-center gap-x-8'],
  {
    variants: {
      variant: {
        default: ['bg-primary50 text-primaryMain'],
        success: ['bg-success50 text-success300'],
        error: ['bg-error50 text-error300'],
        warning: ['bg-warning50 text-warning300'],
        info: ['bg-info50 text-info300'],
        inactive: ['bg-grayscale50 text-grayscale400'],
      },
      size: {
        large: ['px-12 py-4'],
        default: ['px-12 py-4'],
        small: ['px-12 py-4'],
      },
    },
  },
);

export const TooltipStyles = cva([], {
  variants: {
    variant: {
      default: ['fill-primaryMain'],
      success: ['fill-success300'],
      error: ['fill-error300'],
      warning: ['fill-warning300'],
      info: ['fill-info300'],
      inactive: ['fill-grayscale400'],
    },
  },
});

export type TagStyleVariants = VariantProps<typeof tagStyles>;
